// Renamed from LandingPageEvidence.js
import React from 'react';
import LandingPageEvidence from './LandingPageEvidence';

const ExpertSleepPlan = () => {
  return <LandingPageEvidence />;
};

export default ExpertSleepPlan;
